var MigrationProgressStageView = require( './MigrationProgressStage-view.js' );
var $ = jQuery;

var MigrationProgressView = Backbone.View.extend( {
	tagName: 'div',
	className: 'migration-progress-stages',
	id: 'migration-progress-stages',
	self: this,
	initialize: function() {
		this.$el.empty();

		this.model.on( 'stage:added', function( stageModel ) {
			this.addStageView( stageModel );
		}, this );

		_.each( this.model.get( 'stageModels' ), this.addStageView, this );
	},
	addStageView: function( stageModel ) {
		var newStageSubView = new MigrationProgressStageView( {
			model: stageModel
		} );
		stageModel.trigger( 'view:initialized', newStageSubView );
		this.$el.append( newStageSubView.$el );
		this.$el.parent().find( '.stage-tabs' ).append( newStageSubView.$tabElem );
	}
} );

module.exports = MigrationProgressView;



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/modules/MigrationProgress-view.js